import React from "react";
import { motion } from "framer-motion";
import { InnerPageNav, Footer } from "./";
import Charts from "./Charts";
const Tokenomics = () => {
    const data = [
        {
          concentration: 'Ecosystem',
          percent: '23%',
          vest: '3% at TGE. Vested monthly over 7 Years (Operations,reserves)'
        },
        {
          concentration: 'Treasury',
          percent: '19.5%',
          vest: '0% @ TGE, 12 Months Cliff, then monthly vesting over 7 Years.'
        },
        {
          concentration: 'Liquidity',
          percent: '10%',
          vest: '5% at TGE (locked) for 2Yrs. Vested monthly for 3Yrs'
        },
        {
          concentration: 'Angel Sale',
          percent: '4.5%',
          vest: '6 Months Cliff, linear vesting for 12 Months.'
        },
        {
          concentration: 'Private Sale',
          percent: '8%',
          vest: '5% at TGE, 120 Days Cliff, linear vesting for 12 Months'
        },
        {
          concentration: 'Public Sale',
          percent: '20%',
          vest: '20% TGE, 10% Vested for 8 Months.'
        },
        {
          concentration: 'Team',
          percent: '11%',
          vest: '0% @ TGE, 12 Months cliff - Vested monthly over 4 years'
        },
        {
          concentration: 'Advisors',
          percent: '4%',
          vest: '0% @ TGE, 12 Months cliff - Vested monthly over 4 years'
        },
      ]
    
  return (
    <>
      <InnerPageNav />

      <section className="section wf-section mt-20">
        <motion.h1
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: "easeOut", duration: 1 }}
          className="heading-large globalheader1 aligncenter"
        >
          <span className="color-text-gradient">Cloudax Token ($CLDX)</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: "easeOut", duration: 1 }}
          className="text-[#ffffffa3] globalfontsize maxwidth600 aligncenter "
        >
          Cloudax Token ($CLDX) is a BEP-20 utility and governance token that
          powers our rapidly expanding ecosystem. Cloudax token ($CLDX) would
          serve several purposes such as Payments and Access to our Launchpad,
          NFT Marketplace, Fees Payments, e-commerce shopping, in-game
          purchases, Network incentivization and so much more.
        </motion.p>
      </section>

      <section className="section wf-section tok">
        <div className="section-display-wrapper">
          <div className="section wf-section">
            <div className="content-wrapper _40-60">
              <div className="content-block">
                <h1 className="text-style-all-caps globalheader4">
                  How To Get CLDX Token?
                </h1>
                <p className="globalfontsize">
                  Cloudax (CLDX) is the native token of the Cloudax blockchain.
                  There would be a private and public sale on cloudax launchpad.
                  Additional IDO would be done on partner Launchpads. Private
                  sale Participants would be randomly selected from our
                  whitelist event held on our telegram. The public sale would be
                  based on FCFS (First Come, First Serve). Our sale method
                  focuses on fairness for the entire community.
                </p>
              </div>
              <div className="_2-column-grid">
                <div className="icon-block">
                  <div className="colorful-icon large bg-color-accent-4">
                    <img
                      src="../images/checkmark.svg"
                      loading="lazy"
                      alt="Check mark"
                      className="icon"
                    />
                  </div>
                  <div className="icon-block-text-wrapper">
                    <h3 className="text-style-all-caps globalheader4">
                      Cross Chain
                    </h3>
                    <div className="text-small globalfontsize opacity-90">
                      Cloudax token (CLDX) will be deployed across multiple
                      blockchains ( Ethereum, Binance Smart Chain, Polygon and
                      Solana)
                    </div>
                  </div>
                </div>
                <div className="icon-block">
                  <div className="colorful-icon large bg-color-accent-4">
                    <img
                      src="../images/checkmark.svg"
                      loading="lazy"
                      alt="Check mark"
                      className="icon"
                    />
                  </div>
                  <div className="icon-block-text-wrapper">
                    <h3 className="text-style-all-caps globalheader4">
                      Deflationary
                    </h3>
                    <div className="text-small globalfontsize opacity-90">
                      Total Supply is fixed and would be decreased over time by
                      burning. Scarcity by itself creates a demand for the
                      token..
                    </div>
                  </div>
                </div>
                <div className="icon-block">
                  <div className="colorful-icon large bg-color-accent-4">
                    <img
                      src="../images/checkmark.svg"
                      loading="lazy"
                      alt="Check mark"
                      className="icon"
                    />
                  </div>
                  <div className="icon-block-text-wrapper">
                    <h3 className="text-style-all-caps globalheader4">
                      Decentralized
                    </h3>
                    <div className="text-small globalfontsize opacity-90">
                      CLDX Token gives users access to variety of services which
                      includes staking, lending and loans,
                    </div>
                  </div>
                </div>
                {/* <div className="icon-block">
              <img
                    src="../images/dollcoin.jpg"
                    loading="lazy"
                    alt="Check mark"
                    className="icon"
                  />
              </div> */}
                <div className="icon-block">
                  <div className="colorful-icon large bg-color-accent-4">
                    <img
                      src="../images/checkmark.svg"
                      loading="lazy"
                      alt="Check mark"
                      className="icon"
                    />
                  </div>
                  <div className="icon-block-text-wrapper">
                    <h3 className="text-style-all-caps globalheader4">
                      Tokenomics
                    </h3>
                    <div className="text-small globalfontsize opacity-90">
                      Cloudax (CLDX) is the native token of the Cloudax
                      blockchain. There would be a private and public sale on
                      cloudax launchpad.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div id="tokenomicschart" className="section top wf-section">
        <div className="content-wrapper _2-column-grid">
          <div
            id="w-node-_387564a6-a7ba-d4d6-6484-11c9ba1512c5-a2718ffa"
            className="content-block"
          >
            {/* <div className="text-style-all-caps globalheader4">
              Distribution By Charts
            </div> */}

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="w-full maxwidth400"
            >
              <Charts />
            </motion.div>
          </div>
          <div id="" className="image-block">
            <div className="content-wrapper _2-column-grid">
              <div className="gradient-border _16px-radius">
                <div className="quote-container flexContainer">
                  <img
                    src="images/checkmark_1.svg"
                    loading="lazy"
                    alt=""
                    className="quote-image small imageSmaller"
                  />
                  <div className="quote-content" style={{ padding: 0 }}>
                    <div className="metric-block-content">
                      <h3 className="heading-xlarge no-margin">$0.004</h3>
                      <div>Public Price</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="gradient-border _16px-radius">
                <div className="quote-container flexContainer">
                  <img
                    src="images/checkmark_1.svg"
                    loading="lazy"
                    alt=""
                    className="quote-image small imageSmaller"
                  />
                  <div className="quote-content" style={{ padding: 0 }}>
                    <div className="metric-block-content">
                      <h3 className="heading-xlarge no-margin">10B</h3>
                      <div>Total Supply</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="gradient-border _16px-radius">
                <div className="quote-container flexContainer">
                  <img
                    src="images/checkmark_1.svg"
                    loading="lazy"
                    alt=""
                    className="quote-image small imageSmaller"
                  />
                  <div className="quote-content" style={{ padding: 0 }}>
                    <div className="metric-block-content">
                      <h3 className="heading-xlarge no-margin">559M</h3>
                      <div>Initial Circulating Supply</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="gradient-border _16px-radius">
                <div className="quote-container flexContainer">
                  <img
                    src="images/checkmark_1.svg"
                    loading="lazy"
                    alt=""
                    className="quote-image small imageSmaller"
                  />
                  <div className="quote-content" style={{ padding: 0 }}>
                    <div className="metric-block-content">
                      <h3 className="heading-xlarge no-margin">$2,236,000</h3>
                      <div>Initial Market Cap</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <section className="tokdis">

      <div className="w-11/12 mx-auto my-[8rem]">
            <div className='text-center w-11/12 md:w-3/4  lg:w-2/4 xl:w-2/5 mx-auto my-10'>
              <motion.h3 initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} transition={{ ease: "easeOut", duration: 1 }} className="text-[1.5rem] md:text-[2rem] lg:text-[3rem] leading-none mb-5 font-semibold">Token distribution</motion.h3>
              {/* <motion.p initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ ease: "easeOut", duration: 1 }} className=' lg:leading-relaxed'>Cloudax (CLDX) is the native token of the Cloudax blockchain. There would be a private and public sale on cloudax launchpad.</motion.p> */}
            </div>
            <div className="rounded-tr-xl rounded-tl-xl overflow-y-hidden">
              <div className="uppercase flex text-white font-semibold  justify-between  bg-[#3DAEFA] py-6 ">
                <p className="ml-[5%] w-[30%] break-words">Concentration</p>
                <p className="w-[10%] text-center ">%</p>
                <p className="mr-[5%] w-[30%] break-words">VESTING PERIOD</p>
              </div>
              {data.map(({ concentration, vest, percent }, index) => <div key={index} className=" flex justify-between py-6 border-b border-x ">
                <p className="ml-[5%] w-[30%]">{concentration}</p>
                <p className="w-[10%] text-center">{percent}</p>
                <p className="mr-[5%] w-[30%] break-words">{vest}</p>
              </div>)}
            </div>
          </div>
      </section>

      <Footer />
    </>
  );
};

export default Tokenomics;
